import http from './httpService';
import {encodeQueryData} from '../../Utils/Common';
const API_URL_LTV = process.env.REACT_APP_API_URL_LTV;
const API_URL_TARGET = process.env.REACT_APP_API_URL_TARGET;


async function getLtvData(params:any) {
    const url = `${API_URL_LTV}get_ltv_data?`+encodeQueryData(params);
    let response = await http.get(url);
    return response;
}

async function updateLtvData(params:any,where:any) {
    const url = `${API_URL_TARGET}LTV_loandata_update?`+encodeQueryData(where);;
    let response = await http.put(url, params);
    return response;
}

async function getLtvSummaryData(params:any) {
    const url = `${API_URL_LTV}get_ltv_summary?`+encodeQueryData(params);
    let response = await http.get(url);
    return response;
}

const LtvAnalysisServices = {
    getLtvData,
    updateLtvData,
    getLtvSummaryData
};

export default LtvAnalysisServices;